/* eslint-disable no-underscore-dangle */
module.exports = (function() {
  const _ = require("lodash");
  const typeStringToMongooseType = {
    "string": "String",
    "boolean": "Boolean",
    "number": "Number",
    "integer": "Number",
  };
  const typeRefToMongooseType = {
    // "#/definitions/objectid": mongoose.Schema.Types.ObjectId,
    "#/definitions/dateOrDatetime": Date,
  };

  const subSchemaTypeV3 = function(parentSchema, subschema, key) {
    if (parentSchema.required.indexOf(key) >= 0 && !_.isPlainObject(subschema)) {
      return {type: subschema, required: true};
    } else {
      return subschema;
    }
  };

  const subSchemaTypeV4 = function(parentSchema, subschema, key) {
    if (parentSchema.required.indexOf(key) >= 0) {
      if (!_.isPlainObject(subschema)) {
        return {type: subschema, required: true};
      } else if (subschema.hasOwnProperty("type")) {
        return _.assign(subschema, {required: true});
      } else {
        return subschema;
      }
    } else {
      return subschema;
    }
  };

  const schemaParamsToMongoose = {
    /**
    * default value
    */
    default: function(default_) {
      const func = (_.last(/^\[Function=(.+)\]$/.exec(default_)) || "")
        .replace(/\\_/g, "`underscore`")
        .replace(/_/g, " ")
        .replace(/`underscore`/g, "_");
      return {
        default: eval(func) || default_,
      };
    },
    /**
    * Pattern for value to match
    */
    pattern: function(pattern) {
      return {match: RegExp(pattern)};
    },
    type: function(type) {
      return {type: typeStringToMongooseType[type]};
    },
    minLength: function(min) {
      return {minlength: min};
    },
    maxLength: function(max) {
      return {maxlength: max};
    },
    minimum: function(min) {
      return {min: min};
    },
    maximum: function(max) {
      return {max: max};
    },
    enum: function(members) {
      return {enum: members};
    },
  };

  const toMongooseParams = function(acc, val, key) {
    let func;
    return (func = schemaParamsToMongoose[key]) ? _.assign(acc, func(val)) : acc;
  };

  const unsupportedRefValue = function(jsonSchema) {
    throw new Error(`Unsupported $ref value: ${jsonSchema.$ref}`);
  };

  const unsupportedJsonSchema = function(jsonSchema) {
    throw new Error(`Unsupported JSON schema type, '${jsonSchema.type}'`);
  };

  const convert = function(refSchemas, jsonSchema) {
    if (jsonSchema.$schema === "http://json-schema.org/draft-03/schema#") {
      return convertV(3, refSchemas, jsonSchema);
    } else if (jsonSchema.$schema === "http://json-schema.org/draft-04/schema#") {
      return convertV(4, refSchemas, jsonSchema);
    } else { // backwards compatibility
      return convertV(3, refSchemas, jsonSchema);
    }
  };

  const convertV = function(version, refSchemas, jsonSchema) {
    if (!_.isPlainObject(jsonSchema)) {
      unsupportedJsonSchema(jsonSchema);
    }

    const format = jsonSchema.format;
    const isRef = !_.isEmpty(jsonSchema.$ref);
    const isTypeDate = jsonSchema.type === "string" && (format === "date" || format === "date-time");
    const mongooseRef = typeRefToMongooseType[jsonSchema.$ref];
    const isMongooseRef = typeof (mongooseRef) !== "undefined";
    const subSchema = _.isEmpty(refSchemas) ? false : refSchemas[jsonSchema.$ref];
    const subSchemaType = (version === 4) ? subSchemaTypeV4 : subSchemaTypeV3;

    let result;
    if (isRef) {
      if (isMongooseRef) {
        result = mongooseRef;
      } else {
        if (subSchema) {
          result = convertV(version, refSchemas, subSchema);
        } else {
          result = unsupportedRefValue(jsonSchema);
        }
      }
    } else if (isTypeDate) {
      result = _.reduce(
        _.omit(jsonSchema, "type", "format"),
        toMongooseParams,
        {type: typeRefToMongooseType["#/definitions/dateOrDatetime"]}
      );
    } else {
      if (_.has(typeStringToMongooseType, jsonSchema.type)) {
        result = _.reduce(jsonSchema, toMongooseParams, {});
      } else if (jsonSchema.type === "object") {
        if (_.isEmpty(jsonSchema.properties)) {
          result = {};
        } else {
          const converted = _.mapValues(jsonSchema.properties, convertV.bind(null, version, refSchemas));
          if (jsonSchema.required) {
            result = _.mapValues(converted, subSchemaType.bind(null, jsonSchema));
          } else {
            result = converted;
          }
        }
      } else if (jsonSchema.type === "array") {
        if (!_.isEmpty(jsonSchema.items)) {
          const subDoc = convertV(version, refSchemas, jsonSchema.items);
          // Prevent object sub-documents from being assigned an _id property.
          if (subDoc && typeof subDoc === "object" && (!subDoc.type || typeof subDoc.type !== "string")) {
            subDoc._id = false;
          }
          result = [subDoc];
        } else {
          result = [];
        }
      } else if (!_.has(jsonSchema, "type")) {
        result = {};
      } else {
        result = unsupportedJsonSchema(jsonSchema);
      }
    }

    return result;
  };

  const createMongooseSchema = _.curry(convert);
  return createMongooseSchema;
}());



// WEBPACK FOOTER //
// ./src/json-schema-to-mongoose.js